var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "home_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m32 5 28.08 25.362v3.98h-2.34V59H36.68V42.562h-9.36V59H6.26V34.343H3.92v-3.981z",
    clipRule: "evenodd"
  })));
};
export { SvgHome as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMyLjAwMDIgNUw2MC4wODAyIDMwLjM2MTdWMzQuMzQyOEg1Ny43NDAyVjU5SDM2LjY4MDJWNDIuNTYxOUgyNy4zMjAyVjU5SDYuMjYwMTdWMzQuMzQyOEgzLjkyMDE3VjMwLjM2MTdMMzIuMDAwMiA1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";